module.exports = __webpack_public_path__ + "static/media/service_education.27c09f4f.jpg";